<template>
<div class="chapter">
<div class="inner_page">
<h1 class="toc-title"><span class="bold">Contents</span></h1>
<p class="toc"><a href="#/xhtml/04_Chapter01#ch1"><span class="ftoc">Chapter 1</span> Thank God for The Navy! (April 1940)</a></p>
<p class="toc"><span href="#/xhtml/05_Chapter02#ch2" title="Link target outside of Sample"><span class="ftoc">Chapter 2</span> Biplanes Against Battleships – Operation ‘Judgement’ (11–12 November 1940)</span></p>
<p class="toc"><span href="#/xhtml/06_Chapter03#ch3" title="Link target outside of Sample"><span class="ftoc">Chapter 3</span> Operation ‘Excess’ (January 1941)</span></p>
<p class="toc"><span href="#/xhtml/07_Chapter04#ch4" title="Link target outside of Sample"><span class="ftoc">Chapter 4</span> Hunting the <em class="italic">Bismarck</em> (May 1941)</span></p>
<p class="toc"><span href="#/xhtml/08_Chapter05#ch5" title="Link target outside of Sample"><span class="ftoc">Chapter 5</span> Unternehmen ‘Donnerkeil-Zerberus’ (February 1942)</span></p>
<p class="toc"><span href="#/xhtml/09_Chapter06#ch6" title="Link target outside of Sample"><span class="ftoc">Chapter 6</span> Sink The <em class="italic">Tirpitz</em>! (9 March 1942 – 29 August 1944)</span></p>
<p class="toc"><span href="#/xhtml/10_Chapter07#ch7" title="Link target outside of Sample"><span class="ftoc">Chapter 7</span> Hunting the Hunters</span></p>
<p class="toc"><span href="#/xhtml/11_Chapter08#ch8" title="Link target outside of Sample"><span class="ftoc">Chapter 8</span> Pearl Harbor and the US Pacific Fleet</span></p>
<p class="toc"><span href="#/xhtml/12_Chapter09#ch9" title="Link target outside of Sample"><span class="ftoc">Chapter 9</span> Attack On Davao (19 December 1941)</span></p>
<p class="toc"><span href="#/xhtml/13_Chapter10#ch10" title="Link target outside of Sample"><span class="ftoc">Chapter 10</span> Battle of the Coral Sea (4–8 May 1942)</span></p>
<p class="toc"><span href="#/xhtml/14_Chapter11#ch11" title="Link target outside of Sample"><span class="ftoc">Chapter 11</span> The Battle of Midway (4–7 June 1942)</span></p>
<p class="toc"><span href="#/xhtml/15_Chapter12#ch12" title="Link target outside of Sample"><span class="ftoc">Chapter 12</span> The Battle for the Solomons (August–November 1942)</span></p>
<p class="toc"><span href="#/xhtml/16_Chapter13#ch13" title="Link target outside of Sample"><span class="ftoc">Chapter 13</span> The Battle of the Philippine Sea (June 19–20, 1944)</span></p>
<p class="toc"><span href="#/xhtml/17_Chapter14#ch14" title="Link target outside of Sample"><span class="ftoc">Chapter 14</span> The British Pacific Fleet</span></p>
<p class="toc"><span href="#/xhtml/18_Chapter15#ch15" title="Link target outside of Sample"><span class="ftoc">Chapter 15</span> Towards the Final Downfall</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Toc.vue?40dbecfb